module.exports = {"path":["Dashboard","Transaction Group","Transaction List"]}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/components/airticket/search/index.json
// module id = E+dQ
// module chunks = 58